import React from 'react';

import { Link, List, RouterLink, TextTail } from './wrapper';

interface LinkCloudItemProps {
  text: string;
  textTail?: string;
  title: string;
  href?: string;
  to?: string;
}

interface LinkCloudProps {
  items: LinkCloudItemProps[];
}

const LinkCloud = ({ items }: LinkCloudProps) => (
  <List>
    {items.map((item, i) => {
      if (!item.href && !item.to) {
        return null;
      }

      return item.to ? (
        <RouterLink key={`${item.text}-${i}`} to={item.to} title={item.title}>
          {item.text}
          {item.textTail && <TextTail>{item.textTail}</TextTail>}
        </RouterLink>
      ) : (
        <Link key={`${item.text}-${i}`} href={item.href} title={item.title}>
          {item.text}
          {item.textTail && <TextTail>{item.textTail}</TextTail>}
        </Link>
      );
    })}
  </List>
);

export default LinkCloud;
